// Reconstructed from production code; original paths and local names were not available.
import { MEDIA_BASE_URL } from "../services/config.js";
import React from "react";
import * as jsxRuntime from "react/jsx-runtime";
import { useLanguage } from "../context/LanguageContext.jsx";
import { useTheme } from "../context/ThemeContext.jsx";
function footerMediaUrl(l, i) {
  return l || (i ? (i.startsWith("http") ? i : `${MEDIA_BASE_URL}${i}`) : "");
}
function isHttpUrl(l = "") {
  return /^https?:\/\//i.test(String(l || ""));
}
function getMapEmbedUrl(l) {
  const i =
    l?.footer_map_embed_url || l?.footer_map_iframe_url || l?.footer_map_url;
  if (i && isHttpUrl(i)) return i;
  const c = (l?.footer_location || "").trim();
  return c
    ? `https://www.google.com/maps?q=${encodeURIComponent(c)}&output=embed`
    : "";
}
function getMapLinkUrl(l) {
  const i = l?.footer_map_link_url;
  if (i && isHttpUrl(i)) return i;
  const c = (l?.footer_location || "").trim();
  return c
    ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(c)}`
    : "";
}
function SocialIcon({ type: type }) {
  const i = {
    width: 16,
    height: 16,
    fill: "currentColor",
  };
  switch (type) {
    case "facebook":
      return (
        <svg {...i} viewBox={"0 0 24 24"}>
          <path
            d={
              "M13 22v-8h3l1-4h-4V7.5c0-1.1.3-1.8 1.9-1.8H17V2.1C16.7 2 15.6 2 14.3 2 11.5 2 9.6 3.7 9.6 7v3H6v4h3.6v8H13z"
            }
          />
        </svg>
      );
    case "twitter":
      return (
        <svg {...i} viewBox={"0 0 24 24"}>
          <path
            d={
              "M22 5.8c-.8.4-1.6.6-2.5.8.9-.6 1.5-1.4 1.8-2.4-.9.6-1.9 1-3 1.2A4.14 4.14 0 0015.3 4C13 4 11.2 5.9 11.2 8.2c0 .3 0 .7.1 1C8 9 5.3 7.6 3.5 5.4c-.4.7-.6 1.4-.6 2.3 0 1.4.7 2.7 1.9 3.5-.7 0-1.3-.2-1.9-.5v.1c0 2 1.4 3.7 3.3 4.1-.3.1-.7.2-1.1.2-.3 0-.5 0-.8-.1.5 1.6 2.1 2.8 4 2.8A8.3 8.3 0 012 19c1.8 1.1 3.9 1.7 6.1 1.7 7.3 0 11.3-6.2 11.3-11.5v-.5c.8-.6 1.5-1.4 2-2.3z"
            }
          />
        </svg>
      );
    case "linkedin":
      return (
        <svg {...i} viewBox={"0 0 24 24"}>
          <path
            d={
              "M4.98 3.5C4.98 4.88 3.86 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1 4.98 2.12 4.98 3.5zM.29 8.4h4.41V24H.29V8.4zM8.3 8.4h4.23v2.1h.06c.59-1.1 2.03-2.26 4.18-2.26 4.47 0 5.29 2.94 5.29 6.77V24h-4.41v-7.5c0-1.79-.03-4.09-2.49-4.09-2.5 0-2.88 1.94-2.88 3.95V24H8.3V8.4z"
            }
          />
        </svg>
      );
    case "instagram":
      return (
        <svg {...i} viewBox={"0 0 24 24"}>
          <path
            d={
              "M12 7.3A4.7 4.7 0 1016.7 12 4.7 4.7 0 0012 7.3zm0 7.6A2.9 2.9 0 1114.9 12 2.9 2.9 0 0112 14.9z"
            }
          />
          <circle cx={"17.6"} cy={"6.4"} r={"1.1"} />
          <path
            d={
              "M18 2H6A4 4 0 002 6v12a4 4 0 004 4h12a4 4 0 004-4V6a4 4 0 00-4-4zm2.3 16A2.3 2.3 0 0118 20.3H6A2.3 2.3 0 013.7 18V6A2.3 2.3 0 016 3.7h12A2.3 2.3 0 0120.3 6z"
            }
          />
        </svg>
      );
    default:
      return null;
  }
}
function FooterCartIcon({ className: className }) {
  return (
    <svg
      className={className}
      viewBox={"0 0 24 24"}
      fill={"none"}
      stroke={"currentColor"}
      strokeWidth={"1.8"}
      strokeLinecap={"round"}
      strokeLinejoin={"round"}
      aria-hidden={"true"}
    >
      <path d={"M6 6l12 12M18 6l-12 12"} />
    </svg>
  );
}
function Footer() {
  const { theme: theme } = useTheme(),
    { language: language, tProd: tProd, tText } = useLanguage(),
    [s, d] = React.useState(false),
    f = React.useMemo(() => getMapEmbedUrl(theme), [theme]),
    m = React.useMemo(() => getMapLinkUrl(theme), [theme]);
  if (
    (React.useEffect(() => {
      if (!s) return;
      const M = (T) => {
        T.key === "Escape" && d(false);
      };
      document.addEventListener("keydown", M);
      const N = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.removeEventListener("keydown", M);
        document.body.style.overflow = N;
      };
    }, [s]),
    !theme?.footer_enabled)
  )
    return null;
  const y = footerMediaUrl(theme.footer_image, theme.footer_image_url),
    g = footerMediaUrl(theme.logo, theme.logo_url);
  let p = theme.footer_sections || [];
  if ((!p || !p.length) && theme.footer_sections_json)
    try {
      p = JSON.parse(theme.footer_sections_json);
    } catch {
      p = [];
    }
  const b = theme.footer_layout || "horizontal",
    x = theme.footer_mode || "columns",
    O =
      theme.footer_social_facebook ||
      theme.footer_social_twitter ||
      theme.footer_social_linkedin ||
      theme.footer_social_instagram;
  if (!(
    theme.footer_text ||
    theme.footer_location ||
    y ||
    g ||
    (p && p.length) ||
    O
  ))
    return null;
  const E = b === "vertical" ? "footer footer--vertical" : "footer";
  return (
    <jsxRuntime.Fragment>
      <footer className={E}>
        <div className={"footer-inner"}>
          <div className={"footer-brand"}>
            <div className={"footer-logo"}>
              {g && (
                <img
                  src={g}
                  alt={""}
                  aria-hidden={"true"}
                  loading={"lazy"}
                  decoding={"async"}
                />
              )}
              <span>{theme.site_name || "MyShop"}</span>
            </div>
            {theme.footer_text && (
              <p
                className={"footer-text"}
                dangerouslySetInnerHTML={{
                  __html: tProd(theme.footer_text, theme, "footer_text"),
                }}
              />
            )}
            {O && (
              <div className={"footer-social"}>
                {theme.footer_social_facebook && (
                  <a
                    href={theme.footer_social_facebook}
                    target={"_blank"}
                    rel={"noreferrer"}
                    className={"footer-social-link"}
                    aria-label={"Facebook"}
                  >
                    <SocialIcon type={"facebook"} />
                  </a>
                )}
                {theme.footer_social_twitter && (
                  <a
                    href={theme.footer_social_twitter}
                    target={"_blank"}
                    rel={"noreferrer"}
                    className={"footer-social-link"}
                    aria-label={"Twitter"}
                  >
                    <SocialIcon type={"twitter"} />
                  </a>
                )}
                {theme.footer_social_linkedin && (
                  <a
                    href={theme.footer_social_linkedin}
                    target={"_blank"}
                    rel={"noreferrer"}
                    className={"footer-social-link"}
                    aria-label={"LinkedIn"}
                  >
                    <SocialIcon type={"linkedin"} />
                  </a>
                )}
                {theme.footer_social_instagram && (
                  <a
                    href={theme.footer_social_instagram}
                    target={"_blank"}
                    rel={"noreferrer"}
                    className={"footer-social-link"}
                    aria-label={"Instagram"}
                  >
                    <SocialIcon type={"instagram"} />
                  </a>
                )}
              </div>
            )}
            {y && (
              <div className={"footer-image-wrap"}>
                <img
                  src={y}
                  alt={""}
                  aria-hidden={"true"}
                  loading={"lazy"}
                  decoding={"async"}
                />
              </div>
            )}
          </div>
          {x === "columns" && p && p.length > 0 && (
            <div className={"footer-columns"}>
              {p.map((M, N) => {
                const T = (M.title || "").trim(),
                  Y = T.toLowerCase(),
                  $ = Y.includes("location");
                return (
                  <div className={"footer-col"} key={N}>
                    {T && <div className={"footer-col-title"}>{tProd(T)}</div>}
                    {$ && (f || theme.footer_location) && (
                      <div className={"footer-map-block"}>
                        <div className={"footer-map-thumb"}>
                          <button
                            type={"button"}
                            className={"footer-map-preview-button"}
                            onClick={() => d(true)}
                          >
                            {language === "ar" ? "عرض الخريطة" : "See Map"}
                          </button>
                        </div>
                        <div className={"footer-map-row"}>
                          <button
                            type={"button"}
                            className={"footer-map-btn"}
                            onClick={() => d(true)}
                          >
                            {language === "ar" ? "عرض الخريطة" : "See Map"}
                          </button>
                          {m && (
                            <a
                              className={"footer-map-link"}
                              href={m}
                              target={"_blank"}
                              rel={"noreferrer"}
                            >
                              {language === "ar" ? "فتح" : "Open"}
                            </a>
                          )}
                        </div>
                        {theme.footer_location && (
                          <div className={"footer-map-address"}>
                            {theme.footer_location}
                          </div>
                        )}
                      </div>
                    )}
                    <ul>
                      {(M.links || []).map((I, K) => {
                        const J = I && typeof I == "object",
                          Q = J ? I.label : I,
                          W = J ? I.href : "",
                          te = String(Q || "").toLowerCase(),
                          oe = Y.includes("location") && te.includes("map");
                        return (
                          <li key={K}>
                            {oe ? (
                              <button
                                type={"button"}
                                className={"footer-link footer-link-btn"}
                                onClick={() => d(true)}
                              >
                                {tProd(Q)}
                              </button>
                            ) : W ? (
                              <a className={"footer-link"} href={W}>
                                {tProd(Q)}
                              </a>
                            ) : (
                              <span className={"footer-link"}>{tProd(Q)}</span>
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div className={"footer-bottom"}>
          <span>
            {tText("Copyright © ")}
            {new Date().getFullYear()} {theme.site_name || "MyShop"}
            {language === "ar"
              ? ". جميع الحقوق محفوظة"
              : ". All rights reserved."}
          </span>
          <div className={"footer-location"}>
            {theme.footer_location && <span>{theme.footer_location}</span>}
            {(f || m) && (
              <button
                type={"button"}
                className={"footer-mini-map"}
                onClick={() => d(true)}
              >
                {language === "ar" ? "عرض الخريطة" : "See Map"}
              </button>
            )}
          </div>
        </div>
      </footer>
      {s && (
        <div className={"footer-map-modal"} role={"dialog"} aria-modal={"true"}>
          <button
            className={"footer-map-backdrop"}
            aria-label={tText("Close map")}
            onClick={() => d(false)}
          />
          <div className={"footer-map-panel"}>
            <div className={"footer-map-header"}>
              <div className={"footer-map-title"}>
                {theme.site_name
                  ? `${theme.site_name} - ${language === "ar" ? "الموقع" : tText("Location")}`
                  : language === "ar"
                    ? "الموقع"
                    : tText("Location")}
              </div>
              <button
                className={"footer-map-close"}
                onClick={() => d(false)}
                aria-label={tText("Close")}
              >
                <FooterCartIcon className={"icon-18"} />
              </button>
            </div>
            <div className={"footer-map-full"}>
              {f ? (
                <iframe
                  src={f}
                  loading={"lazy"}
                  referrerPolicy={"no-referrer"}
                  allowFullScreen={true}
                  title={tText("Full map")}
                />
              ) : (
                <div className={"footer-map-empty"}>
                  {language === "ar"
                    ? "لم يتم إعداد الخريطة."
                    : "No map configured."}
                </div>
              )}
            </div>
            <div className={"footer-map-actions"}>
              {m && (
                <a
                  className={"footer-map-open"}
                  href={m}
                  target={"_blank"}
                  rel={"noreferrer"}
                >
                  {language === "ar"
                    ? "الفتح في خرائط Google"
                    : "Open in Google Maps"}
                </a>
              )}
            </div>
          </div>
        </div>
      )}
    </jsxRuntime.Fragment>
  );
}
export {
  footerMediaUrl,
  isHttpUrl,
  getMapEmbedUrl,
  getMapLinkUrl,
  SocialIcon,
  FooterCartIcon,
  Footer,
};
